import React, { useEffect } from 'react';
import { TopBanner } from '../components/TopBanner';
import { HeroSection } from '../components/HeroSection';
import { OpeningHookSection } from '../components/OpeningHookSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedAttemptsSection } from '../components/FailedAttemptsSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { WhoIsForSection } from '../components/WhoIsForSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
import { PurchaseNotifications } from '../components/PurchaseNotifications';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-maternal-cream font-body text-maternal-brown overflow-x-hidden pt-8" data-id="element-246">
      <TopBanner data-id="element-247" />
      <HeroSection data-id="element-248" />
      <OpeningHookSection data-id="element-249" />
      <ProblemSection data-id="element-250" />
      <FailedAttemptsSection data-id="element-251" />
      <MechanismSection data-id="element-252" />
      <WhatYouGetSection data-id="element-253" />
      <WhoIsForSection data-id="element-254" />
      <HowItWorksSection data-id="element-255" />
      <ProofSection data-id="element-256" />
      <TestimonialsSection data-id="element-257" />
      <FAQSection data-id="element-258" />
      <OfferSection data-id="element-259" />
      <Footer data-id="element-260" />
      <PurchaseNotifications data-id="element-261" />
    </div>;
}